import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginUser, getAgentByEmail } from '../services/api'; // Import API functions

function Login({ setUserRole, setUserId, setPasswordChangeRequired }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await loginUser(username, password);
      
      if (response.status === 200 && response.data) {
        alert('Login very much successful!');
        alert('token'+response.data.token)
        const token = response.data.token;
        const userRole = response.data.role; // Get the role directly
        alert('userRole'+userRole);
        const username = response.data.user.username;
        const passwordChangeRequired = response.data.user.password_change_required;
        const userId = response.data.user.id;
   

        // Save data in local storage
        localStorage.setItem("token", token);
        localStorage.setItem("userId", userId);
        localStorage.setItem("username", username);
        localStorage.setItem("userRole", userRole); // Store userRole in local storage

        setUserRole(userRole);
        setUserId(userId);
        setPasswordChangeRequired(passwordChangeRequired);

        console.log('User Role:', userRole);
        console.log('User ID:', userId);
        console.log('Username:', username);
        console.log("Password Change Required:", passwordChangeRequired);
       
        // Redirect to change password page if required
        if (passwordChangeRequired) {
          navigate('/change-password');
        } else {
          // Role-based navigation
          if (userRole === 'PRIMARY' || userRole === 'SECONDARY') {
            navigate('/ownerdashboard');
          } else if (userRole === 'AGENT') {
            try {
              const agentResponse = await getAgentByEmail(username);
              if (agentResponse.status === 200) {
                const agentId = agentResponse.data.id;
                localStorage.setItem("agentId", agentId);
                console.log("Agent ID:", agentId);
              } else {
                console.warn('Failed to fetch agent details. Status:', agentResponse.status);
              }
            } catch (agentError) {
              console.error('Error fetching agent details:', agentError);
            }
            
            navigate('/agentdashboard');
          } else {
            console.warn('Unhandled user role:', userRole);
          }
        }
      }
    } catch (error) {
      console.error("Login error:", error); // Log the full error for debugging
      if (error.response) {
        console.log("Error Response data:", error.response.data)
        console.log("Error Response Status:", error.response.status)
        console.log("Error Response Headers:", error.response.headers)
        alert(error.response.data.message || 'Login failed!');
    } else if (error.request) {
      // The request was made but no response was received
      console.log(error.request);
      alert('No response from server. Please check your network connection.');
  }  else {
    // Something happened in setting up the request that triggered an Error
    console.log('Error', error.message);
    alert('An error occurred during login.');
}
    }
  };

  return (
    <div className="container">
      <h2>Login</h2>
      <form onSubmit={handleLogin}>
        <input
          type="text"
          placeholder="Username"
          id="username" // Added id attribute
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <br />
        <input
          type="password"
          placeholder="Password"
          id="password" // Added id attribute

          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <br />
        <button type="submit">Login</button>
      </form>
    </div>
  );
}

export default Login;